/** The key printed on the button that already had that action (UX §9.4).
 *
 * This is the whole discoverability mechanism: nothing extra is added to the screen to teach
 * the shortcuts, because the buttons were going to be there anyway. The cap is decoration for
 * assistive technology — the button itself carries `aria-keyshortcuts`, which is announced
 * once and correctly — and it is not drawn at all on a device with no keyboard.
 */
export function Keycap({ keys }: { keys: string[] }) {
  return (
    <span aria-hidden className="ml-1 inline-flex items-center gap-0.5">
      {keys.map((k) => (
        <kbd key={k} className="keycap">{k}</kbd>
      ))}
    </span>
  );
}
